import { toast } from "sonner";

import { ActionData } from "@/utils/handleAction";

//

interface Options {
  enableToastOnError?: boolean;
  errorMessage?: React.ReactNode;
  errorDescription?: React.ReactNode;
}

//

export type ServerAction<T> = () => Promise<ActionData<T> | undefined> | undefined;

//

type RT<T extends (...args: unknown[]) => unknown> = Awaited<ReturnType<T>>;

export type ExtractDataType<T, A extends ServerAction<T>> =
  RT<A> extends { data?: infer D; error?: unknown } | undefined
    ? undefined extends RT<A>
      ? undefined | D
      : D
    : RT<A>;

//

// const data = await executeServerAction(() => {
//   // return 1
//   // return undefined
//   const subscription = false as boolean;
//   if (!subscription) return;
//   return clientApi.invoice.getSubscriptionInvoiceById("");
// });

//

export async function execAction<T, A extends ServerAction<T>>(
  action: A,
  options: Options = {},
): Promise<ExtractDataType<T, A>> {
  try {
    const response = await action();
    if (!response) return response as ExtractDataType<T, A>;
    const { data, error } = response;
    if (error !== undefined) throw new Error(error);

    return data as ExtractDataType<T, A>;
  } catch (error) {
    if (error instanceof Error) {
      console.error("execAction", error.message);

      if (options.enableToastOnError) {
        toast.error(options.errorMessage ?? "Ошибка сервера", {
          description: options.errorDescription ?? error.message,
        });
      }

      Error.captureStackTrace(error, execAction);
    }

    throw error;
  }
}
